import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useReclassificationModal } from '../context/ReclassificationModalContext';

const ReclassificationModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useReclassificationModal();

  const hasValidDate = data.date && data.date >= data.lastOperationDate;

  const classKey = `entire-class-${data.selectedHoldingClass}`;
  const isSameClass =
    data.selectedNewHoldingClass === data.selectedHoldingClass;
  const isDisabledClass = data.disabledKeys.includes(classKey);

  const buttonEnabledScriptureView = data.scriptureView && hasValidDate;
  const buttonEnabledDataView =
    !data.scriptureView && data.historyMovements.length > 0;

  const hasSelectedHoldingClass = !!data.selectedHoldingClass;
  const hasEditedRanges = data.editedRanges.length > 0;
  const isReclassification =
    data.isEntireClassReclassification &&
    hasSelectedHoldingClass &&
    data.selectedNewHoldingClass &&
    !isDisabledClass &&
    !isSameClass;

  const buttonEnabledSaveMovement =
    (hasSelectedHoldingClass && hasEditedRanges) || isReclassification;

  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <Modal.Footer>
      <div className="d-flex justify-content-between w-100">
        {!data.scriptureView && (
          <button
            type="button"
            id="save-movement-button"
            className="btn btn-lg btn-primary"
            onClick={actions.handleSaveMovement}
            disabled={!buttonEnabledSaveMovement}
          >
            {t('SaveMovement')}
          </button>
        )}
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleSaveReclassification}
          disabled={!buttonEnabledScriptureView && !buttonEnabledDataView}
        >
          {buttonText}
        </button>
      </div>
    </Modal.Footer>
  );
};

export default ReclassificationModalFooter;
